import { withSvgIcon } from './withSvgIcon';

export const ImtokenWallet = withSvgIcon(
  <>
    <path
      d="M44.8926 10.9569C46.2656 28.6735 34.2141 37.0277 23.4134 37.9208C13.3756 38.7562 3.91739 32.9083 3.0631 23.9491C2.39187 16.5455 7.21249 13.4055 11.0263 13.0886C14.9316 12.7717 18.2267 15.3068 18.5013 18.3892C18.7759 21.3564 16.8232 22.7104 15.4503 22.8256C14.3824 22.912 13.0094 22.3071 12.8874 20.9819C12.7959 19.8296 13.2535 19.6856 13.1315 18.4756C12.9179 16.3151 10.9347 16.0558 9.83637 16.1422C8.52443 16.2575 6.11412 17.6978 6.44973 21.3276C6.78535 24.9862 10.5076 27.8669 15.3587 27.4636C20.6065 27.0315 24.2677 23.1713 24.5423 17.7555C24.5423 17.4674 24.6033 17.1793 24.7254 16.92C24.7864 16.8048 24.8474 16.6896 24.9084 16.6032C25.0305 16.4303 25.1525 16.2575 25.3356 16.0846C25.4576 15.9406 25.6407 15.7965 25.8237 15.6237C28.112 13.5784 36.3803 8.76749 44.1909 10.2943C44.618 10.3807 44.8621 10.64 44.8926 10.9569Z"
      fill="url(#paint0_linear_3518_45193)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3518_45193"
        x1="42.4688"
        y1="9.89316"
        x2="17.3287"
        y2="47.5808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#11C4D1" />
        <stop offset="1" stopColor="#0062AD" />
      </linearGradient>
    </defs>
  </>,
  { viewBox: '0 0 48 48' },
);
